import { CoreIcon } from '../core-icon';
import gasStationFillSVG from '../../assets/icons/gas-station-fill.svg';
import type { IconProps } from '../core-icon';

export const GasStationFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={gasStationFillSVG} {...props} />;
};
